// export const BASE_URL = "http://quizmastertesting.motion.ac.in";
// export const BASE_URL ="https://quizmastertesting.motion.ac.in/motioneducation"; //development motion client api url
export const BASE_URL = "https://learning.motion.ac.in/motioneducation"; //production motion client api ur
export const BASE_URL_2 = "https://mla.motion.ac.in"; // engage module base url
export const GOAPI_BASE_URL = "https://goapi.motion.ac.in";
// export const BASE_URL = "https://learninguat.motion.ac.in/motioneducation"; // testing motion client api url
// export const BASE_URL = "http://devlearning.motion.ac.in/motioneducation";
// export const PARENT_BASE_URL = "https://learning.motion.ac.in/motioneducation/api/v1/tracker/attendance/report";
export const PARENT_BASE_URL = "https://learning.motion.ac.in/motioneducation/api/v1/tracker/attendance/report";
export const PARENT_STUDENT_ATTENDANCE_URL = "https://learning.motion.ac.in/motioneducation/api/v1/tracker/attendance/report";

/**
 * Fallback only when API does not send start_url.
 * Override via REACT_APP_LIVEKIT_SERVER_URL — must be a working LiveKit root URL.
 */
export const LIVEKIT_SERVER_URL =
  process.env.REACT_APP_LIVEKIT_SERVER_URL || "https://live.motion.ac.in";

// export const BASE_URL = process.env.REACT_APP_BASE_URL;

